import axiosInstance from "../../axiosInstance";

// const base = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
// const BASE_URL = `${base}/hrm/documents/groups`;

const BASE_URL = "/hrm/documents/groups";

/**
 * 📁 Lấy danh sách nhóm tài liệu
 */
export const getDocumentGroups = async () => {
  try {
    const res = await axiosInstance.get(BASE_URL);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi tải danh sách nhóm tài liệu:", error);
    throw error;
  }
};

/**
 * ➕ Tạo Nhóm tài liệu (parent_id null) hoặc Phân loại (parent_id = folder id)
 * @param {Object} data - { group_name, description, parent_id? }
 */
export const createDocumentGroup = async (data) => {
  try {
    const res = await axiosInstance.post(BASE_URL, data);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi tạo nhóm tài liệu:", error);
    throw error;
  }
};

/**
 * ✏️ Cập nhật nhóm / phân loại
 * @param {String} id
 * @param {Object} data - { group_name, description, parent_id? }
 */
export const updateDocumentGroup = async (id, data) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/${id}`, data);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi cập nhật nhóm tài liệu:", error);
    throw error;
  }
};

/**
 * 🗑️ Xóa nhóm tài liệu
 * @param {String} id - ID của nhóm tài liệu
 */
export const deleteDocumentGroup = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi xóa nhóm tài liệu:", error);
    throw error;
  }
};
